import styled from 'styled-components'
import { Button } from '@sainsburys-tech/bolt'

const Heading = styled.h3`
  font-size: ${props => props.theme.font.size['display-2']};
  font-weight: ${props => props.theme.font.weight.bold};
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 25px 0;
`
const ButtonWrapper = styled(Button)`
  margin-right: 10%;
`
const SubHeading = styled.h4`
  font-size: ${props => props.theme.font.size['display-3']};
  font-weight: ${props => props.theme.font.weight.bold};
  margin-bottom: 10px;
`
const PreviewWrapper = styled.div`
  display: flex;
  padding-top: 20px;
`
const DetailsWrapper = styled.div`
  max-width: 100%;
`

const AnswerWrapper = styled.div`
  padding-left: 50px;
  padding-top: 20px;
  padding-bottom: 20px;
`
const IconWrapper = styled.div`
  margin-right: 8px;
`
const Icon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  text-align: center;
  background-color: ${props => props.theme.color.monochrome.lighter};
`

const AnswerIcon = styled.div`
  width: 24px;
  height: 24px;
  font-weight: ${props => props.theme.font.weight.bold};
`
const AnswerHeading = styled.span`
  display: flex;
`

const AnswerDetails = styled.div`
  padding-left: 24px;
  padding-bottom: 20px;
`

const Nickname = styled.span`
  font-weight: ${props => props.theme.font.weight.bold};
`
const UserDetails = styled.div`
  margin: ${props => (props.type === 'question' ? '16px 0;' : '')};
`
const ErrorMessage = styled.div`
  font-size: ${props => props.theme.font.size.caption};
  font-weight: ${props => props.theme.font.weight.bold};
  color: ${props => props.theme.color.semantic.error.base};
  margin-bottom: 7px;
`

export {
  Heading,
  SubHeading,
  ButtonContainer,
  ButtonWrapper,
  PreviewWrapper,
  DetailsWrapper,
  AnswerWrapper,
  AnswerHeading,
  AnswerDetails,
  IconWrapper,
  Icon,
  AnswerIcon,
  Nickname,
  UserDetails,
  ErrorMessage
}
